'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalWizardComponent = exports.rentalWizardComponent = {
    transclude: true,
    template: require('./rental-wizard.html'),
    controllerAs: 'vmWizard',
    bindings: {
        onFinish: '&',
        onCancel: '&'
    },
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.next = next;
        vm.previous = previous;
        vm.registerStep = registerStep;
        vm.finish = finish;
        vm.cancel = cancel;
        vm.registerMenuStep = registerMenuStep;
        vm.steps = [];
        vm.activeStepIndex = 0;
        vm.$onInit = init;
        vm.menuSteps = [];

        function init() {
            // vm.steps[0].isActive = true;
        }

        function registerStep(step) {
            if (vm.steps.length === 0) {
                vm.steps.push(step);
                vm.steps[0].setIsActive();
            } else {
                vm.steps.push(step);
            }
        }

        function registerMenuStep(step) {
            vm.menuSteps.push(step);
        }

        function next(callback) {
            if (vm.steps.length) {
                vm.activeStepIndex += 1;
                vm.steps[vm.activeStepIndex - 1].setIsActive(); //hide previous step     
                vm.steps[vm.activeStepIndex].setIsActive(); //show next step
            }

            if (angular.isFunction(callback)) {
                callback();
            }
        }

        function previous() {
            if (vm.steps.length) {
                vm.activeStepIndex -= 1;
                vm.steps[vm.activeStepIndex + 1].setIsActive(); // hide previous step
                vm.steps[vm.activeStepIndex].setIsActive(); // show next step
            }
        }

        function finish() {
            vm.onFinish();
        }

        function cancel() {
            vm.onCancel();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard.js
// module id = 995
// module chunks = 0